import { Link, useLocation } from 'react-router-dom'

type Filter = 'all' | 'favorites'

interface Props {
  filter?: Filter
  onFilterChange?: (f: Filter) => void
  activeTag?: string | null
  onClearTag?: () => void
}

export default function TabBar({ filter, onFilterChange, activeTag, onClearTag }: Props) {
  const { pathname } = useLocation()
  const isDiscover = pathname === '/discover'

  function filterClass(f: Filter) {
    return `filter-btn${!isDiscover && filter === f ? ' active' : ''}`
  }

  function FilterTab({ f, label }: { f: Filter; label: string }) {
    const isActive = !isDiscover && filter === f
    if (onFilterChange) {
      return (
        <button
          className={filterClass(f)}
          onClick={() => onFilterChange(f)}
          aria-pressed={isActive}
        >
          {label}
        </button>
      )
    }
    const to = f === 'all' ? '/' : `/?filter=${f}`
    return (
      <Link to={to} className={filterClass(f)} aria-current={isActive ? 'page' : undefined}>
        {label}
      </Link>
    )
  }

  return (
    <nav className="filters" aria-label="Library filters">
      <FilterTab f="all" label="Saved" />
      <Link
        to="/discover"
        className={`filter-btn${isDiscover ? ' active' : ''}`}
        aria-current={isDiscover ? 'page' : undefined}
      >
        Discover
      </Link>
      <FilterTab f="favorites" label="Favorites" />
      {activeTag && onClearTag && (
        <button
          className="filter-btn filter-btn-tag active"
          onClick={onClearTag}
          aria-label={`Clear ${activeTag} tag filter`}
        >
          #{activeTag} ×
        </button>
      )}
    </nav>
  )
}
